import { BehaviorSubject } from 'rxjs';
export function modify(f) {
    return function (subject) { return function () { return subject.next(f(subject.value)); }; };
}
export function read(subject) {
    return function () { return subject.value; };
}
export function write(value) {
    return function (subject) { return function () { return subject.next(value); }; };
}
export function newBehaviorSubject(a) {
    return function () { return new BehaviorSubject(a); };
}
